import { useContext } from "react";
import { Formik, Form } from "formik";
import Input from "./Input";
import { contextWeb3 } from "../contexts/ProviderWeb3";
import { DAI_TOKEN } from "../helpers";
import ERC20Abi from "../config/abis/ERC20.json";

const styles = {
  title: {
    textAlign: "center",
    fontWeight: "200",
  },
  container: {
    width: "70%",
    display: "flex",
    justifyContent: "center",
  },
};
export default function Faucet({ token }) {
  const { web3 } = useContext(contextWeb3);

  const handleSubmit = async ({ amount }) => {
    const dai = new web3.eth.Contract(ERC20Abi, DAI_TOKEN);
    await dai.methods
      .faucet(web3.utils.toWei(amount.toString(), "ether"))
      .call();
  };
  return (
    <div>
      <h1 style={styles.title}>Faucet {token}</h1>

      <div style={styles.container}>
        <Formik initialValues={{ amount: 0 }} onSubmit={handleSubmit}>
          <Form>
            <Input name="amount" label="Introduzca Cantidad" />
            <button type="submit">Enviar</button>
          </Form>
        </Formik>
      </div>
    </div>
  );
}
